import { gql } from '@apollo/client'

/*
  Login user
*/

export const GQL_MUTATION_LOGIN = gql`
  mutation ($credentials: InputBrandManagerCredentials!) {
    login(credentials: $credentials) {
      id
      status
      assembler_id
    }
  }
`

/*
  Logout user
*/

export const GQL_MUTATION_LOGOUT = gql`
  mutation {
    logout
  }
`

/*
  Query to grab current user info
*/

export const GQL_QUERY_PING_AUTH = gql`
  query {
    pingAuth {
      id
      status
      brands {
        id
        slug
      }
      assembler_id
    }
  }
`
